import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const nonBinTrackedColumns = [
    {
        dataField: 'LotSerial',
        caption: 'Serial',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.lg0,
        fixed: true,
        allowSorting: true,
        allowEditing: false,
    },
];
